import type { Template } from '../types/wizard';

const physicsWritten: Template = {
  id: 'physics-written',
  name: 'Physics Written',
  description: 'Physics Written Question Pattern',
  subjectId: 'hsc-physics',
  examType: 'written',
  version: 'Bangla',
  totalQuestions: 8,
  stimulusInstruction:
    'Write a 2-4 sentence real-world or lab scenario involving a physics concept from the chapter (e.g. a student observing a phenomenon, an experiment, or a practical situation). The scenario must contain numerical values or observable conditions that the question parts can be based on.',
  banglaStimlusInstruction:
    'সংশ্লিষ্ট অধ্যায়ের পদার্থবিজ্ঞানের ধারণা সম্বলিত ২-৪ বাক্যের একটি বাস্তব বা প্রযোগশালার ঘটনা লেখো (যেমন: একজন ছাত্র পর্যবেক্ষণ করছে, প্রয়োগ করতেসে, বা বাস্তব পরিস্থিতির মুখোমুখি)। ঘটনায় সংখ্যাসূচক মান বা পরিমাপযোগ্য বিষয় থাকা সাধারণত প্রয়োজন।',
  parts: [
    {
      label: 'ক',
      banglaLabel: 'ক',
      englishLabel: 'a',
      marks: 1,
      questionType: 'Definition',
      answerType: 'Short Answer',
      expectedAnswerLength: '1-2 lines',
      difficulty: 'Easy',
      requiresCalculation: false,
      requiresReasoning: false,
      requiresDiagram: false,
      aiInstruction: 'Ask a simple conceptual or definition-based question.',
      banglaAiInstruction: 'একটি সহজ ধারণামূলক বা সংজ্ঞাভিত্তিক প্রশ্ন করো।',
    },
    {
      label: 'খ',
      banglaLabel: 'খ',
      englishLabel: 'b',
      marks: 2,
      questionType: 'Explanation',
      answerType: 'Descriptive',
      expectedAnswerLength: '2-5 lines',
      difficulty: 'Medium',
      requiresCalculation: false,
      requiresReasoning: true,
      requiresDiagram: false,
      aiInstruction: 'Generate an analytical or explanatory question based on the uploaded notes.',
      banglaAiInstruction:
        'আপলোড করা নোটের উপর ভিত্তি করে একটি বিশ্লেষণমূলক বা ব্যাখ্যামূলক প্রশ্ন তৈরি করো।',
    },
    {
      label: 'গ',
      banglaLabel: 'গ',
      englishLabel: 'c',
      marks: 3,
      questionType: 'Numerical',
      answerType: 'Calculation',
      expectedAnswerLength: 'Step-by-step calculation',
      difficulty: 'Medium',
      requiresCalculation: true,
      requiresReasoning: false,
      requiresDiagram: false,
      aiInstruction: 'Generate a numerical problem requiring formula application and calculations.',
      banglaAiInstruction: 'সূত্র প্রয়োগ ও গণনা প্রয়োজন এমন একটি গাণিতিক সমস্যা তৈরি করো।',
    },
    {
      label: 'ঘ',
      banglaLabel: 'ঘ',
      englishLabel: 'd',
      marks: 4,
      questionType: 'Numerical + Reasoning',
      answerType: 'Calculation + Explanation',
      expectedAnswerLength: 'Detailed solution with reasoning',
      difficulty: 'Hard',
      requiresCalculation: true,
      requiresReasoning: true,
      requiresDiagram: false,
      aiInstruction:
        'Generate a higher-order problem requiring calculation, reasoning, and analysis. Prefer real-world scenarios when appropriate.',
      banglaAiInstruction:
        'গণনা, যুক্তি ও বিশ্লেষণ প্রয়োজন এমন একটি উচ্চ-মানের সমস্যা তৈরি করো। প্রযোজ্য ক্ষেত্রে বাস্তব জীবনের পরিস্থিতি ব্যবহার করো।',
    },
  ],
} as Template;

const physicsMCQ: Template = {
  id: 'physics-mcq',
  name: 'Physics MCQ',
  description: 'Physics MCQ Pattern',
  subjectId: 'hsc-physics',
  examType: 'mcq',
  version: 'Bangla',
  totalQuestions: 25,
  parts: [
    {
      label: 'MCQ',
      banglaLabel: 'MCQ',
      englishLabel: 'MCQ',
      marks: 1,
      questionType: 'Multiple Choice',
      answerType: 'Single Selection',
      expectedAnswerLength: 'One option',
      difficulty: 'Mixed',
      requiresCalculation: false,
      requiresReasoning: false,
      requiresDiagram: false,
      aiInstruction:
        'Generate a 4-option MCQ with one correct answer. Cover conceptual and numerical topics.',
      banglaAiInstruction:
        'একটি সঠিক উত্তরসহ ৪টি বিকল্পবিশিষ্ট MCQ তৈরি করো। ধারণামূলক ও গাণিতিক বিষয় অন্তর্ভুক্ত করো।',
    },
  ],
} as Template;

export const templates: Template[] = [physicsWritten, physicsMCQ];

export function getTemplates(subjectId: string, examType: string): Template[] {
  return templates.filter((t) => t.subjectId === subjectId && t.examType === examType);
}
